import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { G_API } from "../../constants/globalVar";
import SocialShareButton from "../Button/SocialShareButtons";
import DefaulHelmet from "../Helmet";
import ReactGA from 'react-ga4';

export default function DetailPage() {
    const { id } = useParams();
    const [item, setItem] = useState(null);
    const [formattedDate, setFormattedDate] = useState("");
    const defaultImage = G_API + "uploads/ahnyar-logo.png";
    const currentUrl = window.location.href;

    useEffect(() => {
        const config = {
            method: "post",
            maxBodyLength: Infinity,
            url: `${G_API}blogs/BLOG_LIST?id=${id}`,
            headers: {},
            data: "",
        };

        axios(config)
            .then((response) => {
                const item = response.data.DATAS;
                setItem(item);

                const formattedDate = new Date(item.updated_at).toLocaleDateString("en-GB", {
                    day: "2-digit",
                    month: "long",
                    year: "numeric",
                });
                setFormattedDate(formattedDate);
            })
            .catch((error) => {
                console.error(error);
            });
    }, [id]);

    function openShare() {
        ReactGA.event({
            category: 'Blog',
            action: 'blog_share_btn_clicked',
            label: item ? item.title : 'Blog',
        });
    }

    return (
        <>
            {item ? (
                <div>
                    <DefaulHelmet
                        title={item.title}
                        description={item.content}
                        image={item.feature_img}
                        type="article"
                        url={currentUrl}
                    />

                    <div
                        id="header-carousel"
                        className="carousel slide"
                        data-bs-ride="carousel"
                        style={{ height: "180px", backgroundColor: "#002" }}
                    ></div>

                    <div className="container lh-lg">
                        <div
                            className="border bg-white rounded container my-4 mx-auto py-5 px-5"
                            style={{ margin: "0 auto", maxWidth: "800px" }}
                        >
                            <div className="grid">
                                <div className="row">
                                    <div className="col text-center">
                                        <h3 className="text-uppercase">{item.title}</h3>
                                    </div>
                                </div>

                                <div className="row pb-3 pt-3">
                                    <div className="col" style={{ fontSize: "12px" }}>
                                        <img
                                            src="/assets/ani-logo.png"
                                            alt=""
                                            className="logo-small shadow-sm"
                                            style={{
                                                width: "24px",
                                                height: "24px",
                                                borderRadius: "50%",
                                                marginRight: "8px",
                                            }}
                                        />
                                        <span className="opacity-50">By</span>{" "}
                                        <i>{item.author}</i> ~ {formattedDate}{" "}
                                        <span className="opacity-50 text-xs">
                                            | Reading Time: {item.reading_time}
                                        </span>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col">
                                        {item.feature_img?.src && (
                                            <img
                                                className="w-100 h-auto"
                                                src={item.feature_img.src ?? defaultImage}
                                                alt=""
                                            />
                                        )}

                                        <div
                                            className="my-4"
                                            dangerouslySetInnerHTML={{ __html: item.content }}
                                        />

                                        <div className="row">
                                            {item.blog_img1 && (
                                                <div className="col-6">
                                                    <img
                                                        className="w-100 h-auto"
                                                        src={item.blog_img1.src}
                                                        alt=""
                                                    />
                                                </div>
                                            )}
                                            {item.blog_img2 && (
                                                <div className="col-6">
                                                    <img
                                                        className="w-100 h-auto"
                                                        src={item.blog_img2.src}
                                                        alt=""
                                                    />
                                                </div>
                                            )}
                                        </div>

                                        <div className="d-flex justify-content-between mt-4">
                                            <div>
                                                <span className="opacity-50">Tags: </span>
                                                <span>
                                                {((item.tags !== undefined) ? item.tags.map((tag, index) => (
                                                    <a key={index} className="badge bg-secondary me-1 text-decoration-none" href={tag.title ? `/blogs/tags/${tag.title}` : "#"}>
                                                        {tag.title}
                                                    </a>
                                                )) : null)}
                                                </span>
                                            </div>
                                            <SocialShareButton title={item.title} onClick={openShare} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div>
                    <span>Loading...</span>
                </div>
            )}

            <section className="container">
                <div
                    className="card my-4 mx-auto py-2 px-0"
                    style={{ margin: "0 auto", maxWidth: "800px" }}
                >
                    <a
                        className="row text-decoration-none text-black"
                        style={{ minWidth: "200px", cursor: "pointer" }}
                        href="/"
                    >
                        <div className="col-4">
                            <img
                                src="/assets/ahnyar-logo.png"
                                alt=""
                                className="w-100 p-2"
                            />
                        </div>
                        <div className="col-6 py-5">
                            <h4 className="text-center fs-2">Ah Nyar Institute</h4>
                        </div>
                    </a>
                </div>
            </section>
        </>
    );
}
